import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import QRCode from 'qrcode'
import jsPDF from 'jspdf'

const API = 'https://legado-digital-production.up.railway.app'

function SiAlgoPasa({ userId }) {
  const [perfil, setPerfil] = useState(null)
  const [guardian, setGuardian] = useState(null)
  const [qrUrl, setQrUrl] = useState('')
  const [enviandoAlerta, setEnviandoAlerta] = useState(false)
  const [mensajeAlerta, setMensajeAlerta] = useState('')
  const [errorAlerta, setErrorAlerta] = useState('')
  const [escenario, setEscenario] = useState(null)
  const [cargando, setCargando] = useState(true)

  useEffect(() => { cargarDatos() }, [userId])

  async function cargarDatos() {
    setCargando(true)
    try {
      const [resPerfil, resGuardian] = await Promise.all([
        fetch(`${API}/api/perfil?userId=${userId}`),
        fetch(`${API}/api/heirs?userId=${userId}`),
      ])
      const [dataPerfil, dataGuardian] = await Promise.all([
        resPerfil.json(),
        resGuardian.json(),
      ])
      if (dataPerfil.ok && dataPerfil.datos) setPerfil(dataPerfil.datos)
      if (dataGuardian.ok && dataGuardian.datos) {
        const g = dataGuardian.datos.find(h => h.rol === 'confirmer')
        setGuardian(g || null)
      }
      // Generar QR con URL pública de emergencia
      const urlEmergencia = `${window.location.origin}/emergencia?uid=${userId}`
      const qr = await QRCode.toDataURL(urlEmergencia, { width: 200, margin: 1 })
      setQrUrl(qr)
    } catch (err) {
      console.error(err)
    } finally {
      setCargando(false)
    }
  }

  async function activarAlertaInmediata() {
    setEnviandoAlerta(true)
    setMensajeAlerta('')
    setErrorAlerta('')
    try {
      const res = await fetch(`${API}/api/switch/${userId}/alerta-inmediata`, {
        method: 'POST',
      })
      const datos = await res.json()
      if (!datos.ok) { setErrorAlerta(datos.error); return }
      setMensajeAlerta('✓ Alerta enviada a tu guardián correctamente.')
    } catch {
      setErrorAlerta('Error al enviar la alerta. Inténtalo de nuevo.')
    } finally {
      setEnviandoAlerta(false)
    }
  }

  function generarPDF() {
    const doc = new jsPDF()
    const p = perfil || {}

    // Header
    doc.setFillColor(44, 24, 16)
    doc.rect(0, 0, 210, 30, 'F')
    doc.setTextColor(250, 248, 245)
    doc.setFontSize(18)
    doc.setFont('helvetica', 'bold')
    doc.text('ETERN-ME — Información de Emergencia', 14, 20)

    // Datos médicos
    doc.setTextColor(44, 24, 16)
    doc.setFontSize(14)
    doc.setFont('helvetica', 'bold')
    doc.text('Datos Médicos Críticos', 14, 45)

    doc.setFontSize(11)
    doc.setFont('helvetica', 'normal')
    const datos = [
      ['Nombre completo', p.nombre_completo || 'No especificado'],
      ['Tipo de sangre', p.tipo_sangre || 'No especificado'],
      ['Médico de cabecera', p.medico_cabecera || 'No especificado'],
      ['Contacto de emergencia', p.contacto_emergencia || 'No especificado'],
      ['Teléfono', p.telefono || 'No especificado'],
      ['Dirección', p.direccion || 'No especificado'],
      ['Seguridad social', p.seguridad_social || 'No especificado'],
    ]

    let y = 55
    datos.forEach(([label, valor]) => {
      doc.setFont('helvetica', 'bold')
      doc.text(label + ':', 14, y)
      doc.setFont('helvetica', 'normal')
      doc.text(valor, 80, y)
      y += 10
    })

    // Guardián
    if (guardian) {
      doc.setFontSize(14)
      doc.setFont('helvetica', 'bold')
      doc.text('Contacto de Confianza (Guardián)', 14, y + 10)
      y += 20
      doc.setFontSize(11)
      doc.setFont('helvetica', 'normal')
      doc.text('Nombre: ' + (guardian.nombre_completo || ''), 14, y)
      doc.text('Email: ' + (guardian.email || ''), 14, y + 10)
      doc.text('Teléfono: ' + (guardian.telefono || 'No especificado'), 14, y + 20)
    }

    // Footer
    doc.setFontSize(9)
    doc.setTextColor(139, 111, 71)
    doc.text('Generado por ETERN-ME — etern-me.com', 14, 285)
    doc.text('Fecha: ' + new Date().toLocaleDateString('es-ES'), 150, 285)

    doc.save('etern-me-emergencia.pdf')
  }

  const ESCENARIOS = [
    {
      key: 'hospitalizado',
      titulo: '🏥 Si estoy hospitalizado/a',
      pasos: [
        'Muestra el QR de emergencia al personal médico para acceder a mis datos críticos.',
        'Contacta a mi guardián — tiene acceso a mi información completa.',
        'Mi tipo de sangre y médico de cabecera están en el PDF de emergencia.',
        'Los documentos importantes están organizados en mi checklist de ETERN-ME.',
      ]
    },
    {
      key: 'incapacitado',
      titulo: '⚠️ Si estoy incapacitado/a temporalmente',
      pasos: [
        'Mi guardián tiene instrucciones sobre cómo gestionar mis asuntos.',
        'Mis cuentas y suscripciones están listadas en ETERN-ME.',
        'Las instrucciones para mis mascotas están guardadas en la sección Mascotas.',
        'Contacta a mi abogado o notario si está especificado en Mis deseos.',
      ]
    },
    {
      key: 'fallecimiento',
      titulo: '🕊️ Si ya no estoy',
      pasos: [
        'Notifica a mi guardián — tiene acceso completo a mi información.',
        'Mis deseos sobre el funeral y entierro están en la sección "Mis deseos".',
        'Las cartas para personas específicas se entregarán cuando el guardián active el acceso.',
        'Todos los documentos importantes están en mi checklist de ETERN-ME.',
      ]
    },
  ]

  if (cargando) return <p style={{ padding: '40px', color: '#8B6F47', textAlign: 'center' }}>Cargando...</p>

  return (
    <div style={estilos.pagina} className="pagina-contenido">
      <div style={estilos.contenido}>

        <div style={estilos.header}>
          <h2 style={estilos.titulo}>SOS</h2>
          <p style={estilos.subtitulo}>Tu plan de emergencia personal. Aquí encuentras tu QR médico, un PDF descargable con tu información crítica y las instrucciones exactas para cada situación. Todo listo para cuando más se necesite.</p>
        </div>

        {/* ALERTA INMEDIATA */}
        <div style={estilos.alertaCard}>
          <div style={estilos.alertaHeader}>
            <span style={estilos.alertaIcono}>🚨</span>
            <div>
              <div style={estilos.alertaTitulo}>Activar alerta ahora</div>
              <div style={estilos.alertaDesc}>
                {guardian
                  ? `Envía una notificación inmediata a ${guardian.nombre_completo || guardian.email} con tus datos médicos críticos.`
                  : 'Necesitas asignar un guardián en "Mis personas" para activar la alerta.'}
              </div>
            </div>
          </div>
          {mensajeAlerta && <div style={estilos.mensajeExito}>{mensajeAlerta}</div>}
          {errorAlerta && <div style={estilos.errorDiv}>{errorAlerta}</div>}
          <button
            onClick={activarAlertaInmediata}
            disabled={enviandoAlerta || !guardian}
            style={{ ...estilos.btnAlerta, opacity: (enviandoAlerta || !guardian) ? 0.6 : 1 }}
          >
            {enviandoAlerta ? 'Enviando...' : '🚨 Activar alerta inmediata'}
          </button>
        </div>

        {/* QR + PDF */}
        <div style={estilos.dosColumnas}>
          <div style={estilos.card}>
            <h3 style={estilos.cardTitulo}>📱 QR de emergencia</h3>
            <p style={estilos.cardDesc}>Muestra este QR al personal médico para acceder a tus datos críticos sin login.</p>
            {qrUrl && <img src={qrUrl} alt="QR emergencia" style={estilos.qrImg} />}
            <p style={estilos.qrNota}>Guarda una captura en tu móvil o imprímelo.</p>
          </div>

          <div style={estilos.card}>
            <h3 style={estilos.cardTitulo}>📄 PDF de emergencia</h3>
            <p style={estilos.cardDesc}>Descarga un PDF con toda tu información crítica para tener siempre a mano.</p>
            {perfil && (
              <div style={estilos.resumenPerfil}>
                <div style={estilos.resumenItem}><span style={estilos.resumenLabel}>Sangre</span><span style={estilos.resumenValor}>{perfil.tipo_sangre || '—'}</span></div>
                <div style={estilos.resumenItem}><span style={estilos.resumenLabel}>Médico</span><span style={estilos.resumenValor}>{perfil.medico_cabecera || '—'}</span></div>
                <div style={estilos.resumenItem}><span style={estilos.resumenLabel}>Emergencia</span><span style={estilos.resumenValor}>{perfil.contacto_emergencia || '—'}</span></div>
              </div>
            )}
            <button onClick={generarPDF} style={estilos.btnPDF}>
              ⬇️ Descargar PDF
            </button>
          </div>
        </div>

        {/* ESCENARIOS */}
        <div style={estilos.escenariosSection}>
          <h3 style={estilos.seccionTitulo}>¿Qué hacer si...?</h3>
          <p style={estilos.seccionDesc}>Instrucciones claras para tus personas de confianza en cada situación.</p>
          <div style={estilos.escenariosGrid}>
            {ESCENARIOS.map(esc => (
              <div key={esc.key} style={estilos.escenarioCard}>
                <button
                  onClick={() => setEscenario(escenario === esc.key ? null : esc.key)}
                  style={estilos.escenarioBtn}
                >
                  <span style={estilos.escenarioTitulo}>{esc.titulo}</span>
                  <span>{escenario === esc.key ? '▲' : '▼'}</span>
                </button>
                {escenario === esc.key && (
                  <div style={estilos.escenarioPasos}>
                    {esc.pasos.map((paso, i) => (
                      <div key={i} style={estilos.paso}>
                        <span style={estilos.pasoNum}>{i + 1}</span>
                        <span style={estilos.pasoTexto}>{paso}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: 'calc(100vh - 64px)', backgroundColor: '#FAF8F5', padding: '32px 16px', scrollMarginTop: '56px' },
  contenido: { maxWidth: '700px', margin: '0 auto' },
  header: { marginBottom: '24px' },
  titulo: { fontSize: '24px', fontWeight: '700', color: '#2C1810', marginBottom: '8px', letterSpacing: '-0.5px' },
  subtitulo: { fontSize: '14px', color: '#8B6F47', lineHeight: '1.7' },
  alertaCard: { backgroundColor: '#FDF0EC', border: '2px solid #8B2E0F', borderRadius: '12px', padding: '20px', marginBottom: '24px' },
  alertaHeader: { display: 'flex', gap: '16px', alignItems: 'flex-start', marginBottom: '16px' },
  alertaIcono: { fontSize: '28px', flexShrink: 0 },
  alertaTitulo: { fontSize: '16px', fontWeight: '700', color: '#8B2E0F', marginBottom: '4px' },
  alertaDesc: { fontSize: '13px', color: '#5C4033', lineHeight: '1.6' },
  btnAlerta: { width: '100%', padding: '14px', backgroundColor: '#8B2E0F', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '700', cursor: 'pointer' },
  dosColumnas: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' },
  card: { backgroundColor: '#FFFFFF', border: '1px solid #E8E0D5', borderRadius: '12px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px' },
  cardTitulo: { fontSize: '15px', fontWeight: '700', color: '#2C1810', margin: 0 },
  cardDesc: { fontSize: '13px', color: '#8B6F47', lineHeight: '1.6', margin: 0 },
  qrImg: { width: '160px', height: '160px', margin: '0 auto', display: 'block', border: '1px solid #E8E0D5', borderRadius: '8px', padding: '8px' },
  qrNota: { fontSize: '11px', color: '#C4A882', textAlign: 'center', margin: 0 },
  resumenPerfil: { display: 'flex', flexDirection: 'column', gap: '8px', backgroundColor: '#FAF8F5', borderRadius: '8px', padding: '12px' },
  resumenItem: { display: 'flex', justifyContent: 'space-between', fontSize: '13px' },
  resumenLabel: { color: '#8B6F47', fontWeight: '500' },
  resumenValor: { color: '#2C1810', fontWeight: '600', textAlign: 'right', maxWidth: '60%' },
  btnPDF: { width: '100%', padding: '12px', backgroundColor: '#2C1810', color: '#FAF8F5', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginTop: 'auto' },
  escenariosSection: { backgroundColor: '#FFFFFF', border: '1px solid #E8E0D5', borderRadius: '12px', padding: '20px' },
  seccionTitulo: { fontSize: '16px', fontWeight: '700', color: '#2C1810', marginBottom: '4px', marginTop: 0 },
  seccionDesc: { fontSize: '13px', color: '#8B6F47', marginBottom: '16px' },
  escenariosGrid: { display: 'flex', flexDirection: 'column', gap: '8px' },
  escenarioCard: { border: '1px solid #E8E0D5', borderRadius: '10px', overflow: 'hidden' },
  escenarioBtn: { width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', backgroundColor: '#FAF8F5', border: 'none', cursor: 'pointer' },
  escenarioTitulo: { fontSize: '14px', fontWeight: '600', color: '#2C1810' },
  escenarioPasos: { padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px', backgroundColor: '#FFFFFF' },
  paso: { display: 'flex', gap: '12px', alignItems: 'flex-start' },
  pasoNum: { width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#2C1810', color: '#FAF8F5', fontSize: '12px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  pasoTexto: { fontSize: '13px', color: '#5C4033', lineHeight: '1.6' },
  mensajeExito: { backgroundColor: '#F0F4E8', color: '#3D4D1F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px', border: '1px solid #C8D5A0' },
  errorDiv: { backgroundColor: '#FDF0EC', color: '#8B2E0F', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px', border: '1px solid #F5C9B8' },
}

export default SiAlgoPasa
